import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemTitle',
  props: {
    url: {
        default: null,
        required: false,
        type: String,
        validator: prop => typeof prop === 'string' || prop === null
    },
    productName: { required: false, default: null, type: String }
},
  setup(__props) {

const props = __props



const hasUrl = computed(() => props.url !== null);

function getUrl(): string {
    if (props.url === null) { return ''; }

    return props.url;
}

return { __sfc: true,props, hasUrl, getUrl }
}

})